module.exports = __webpack_public_path__ + "img/product-placeholder-80.60c9ac6.png";